var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('booking-attendance',{attrs:{"content":_vm.data,"config":_vm.config,"locale":_vm.locale,"isDesktop":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }